// Import base react components
import React, {Component, PropTypes} from 'react';
import {Table, Thead, Th, Tr, Td} from 'components/reactable'

// Import libraries
import i18n from 'lib/i18n'
import c from 'state/constants'
import underscore from 'underscore'

// Import styles and object styles for modals
import styles from '../taskList.scss'

// Setup translation group to agenda2
const _ = i18n('agenda2')

/**
 * Task form
 *
 * Handles task create and edit form
 */
export default class ManageColorsForm extends Component {

    /**
	 * Set the required property types for the component
	 */
	static propTypes = {
        userColors: React.PropTypes.array.isRequired,
        toggleModal: React.PropTypes.func.isRequired,
        setEditAction: React.PropTypes.func.isRequired,
        setNotificationTypeAction: React.PropTypes.func.isRequired
    }

    /**
     * Handle edit action of a color
     */
    handleEditAction(itemId)
    {
        const  { toggleModal, setEditAction } = this.props
        setEditAction('manageColorPicker', itemId)
        toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER)
    }

    /**
     * Handle delete action of a color
     */
    handleDeleteAction(itemId)
    {
        const { setNotificationTypeAction } = this.props
        setNotificationTypeAction('deleteColor', itemId)
        return;

    }

    /**
     * Render
     * Handles the render part for the component
     */
    render() {
        const { userColors, toggleModal } = this.props

		return (
			<div className={styles.todoModalContent}>
				<span className={styles.title}>{_("manageTodoColors")}</span>

                <div className={styles.tableContainer}>
                    {!underscore.isEmpty(userColors) && underscore.isArray(userColors) && (userColors[0] !== 'Too many rows') &&
                        <Table
                            className={styles.table}
                            itemsPerPage={5}
                            topPagination=""
                            filterable={[]}
                        >
                            <Thead>
                            <Th column="colorCode">
                                <strong>{_('label_color')}</strong>
                            </Th>
                            <Th column="label">
                                <strong>{_('title')}</strong>
                            </Th>
                            <Th column="actions">
                                <strong></strong>
                            </Th>
                            </Thead>
                            { userColors.map((item, key) =>
                                <Tr className="centered" key={item.value} >
                                    <Td column="colorCode">
                                        <div style={{
                                            background: item.colorCode,
                                            width: '20px',
                                            height: '20px',
                                            display: 'inline-block',
                                            margin: '0px 0px 0px 5px',
                                            boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.2)'
                                        }}></div>
                                    </Td>
                                    <Td column="label">{item.label}</Td>
                                    <Td column="actions">
                                        <div>
                                            <button type="button"
                                                className={styles.editFieldButton}
                                                onClick={() => {
                                                    this.handleEditAction(item.value)
                                                }}><img src={require('resources/images/a-edit_1x_blue.svg')}/>
                                            </button>

                                            <button type="button"
                                                className={styles.editFieldButton}
                                                onClick={() => {
                                                    this.handleDeleteAction(item.value)
                                                }}><img src={require('resources/images/a-trash_1x_ovbBlue.svg')}/>
                                            </button>
                                        </div>
                                    </Td>
                                </Tr>
                            )
                            }
                        </Table>
                    }
                    {userColors.length == 0 && <div className={styles.noresults}>{_('noTodoColors')}</div>}
                </div>

				<div className={styles.todoModalButtons}>
					<span
						onClick={() => {
                            toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_COLORS)
                        }}
						className={styles.cancel}
					>
						{_("close")}
					</span>
				</div>
			</div>
		)
    }

}



// WEBPACK FOOTER //
// ./components/taskList/components/manageColorsForm.jsx